import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatterySungageApplicationReadDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Reconcile Sungage and return the saved read. A failed refresh keeps the
 * last known terms on the server; the mutation error is the retry signal.
 */
export default function useRefreshBatterySungageApplication(): UseMutationResult<
  BatterySungageApplicationReadDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      batteryProposalService.refreshSungageApplication(
        proposalId,
        applicationId,
      ),
    onSuccess: async (application, { proposalId, applicationId }) => {
      const applicationKey = queryKeys.batteryProposal.sungageApplication(
        proposalId,
        applicationId,
      )
      await queryClient.cancelQueries({ queryKey: applicationKey })
      queryClient.setQueryData(applicationKey, application)
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.financing(proposalId),
      })
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.financialSummary(proposalId),
      })
    },
  })
}
